module.exports = __webpack_public_path__ + "img/test-card.a2000e33.png";